import styled, { css } from 'styled-components'

export const SSMobileMenu = styled.div`
  ${({ theme: { colors, blocks } }) => css`
    background-color: ${colors.white};
    left: 0;
    position: fixed;
    top: ${blocks.menuHeight};
    width: 100%;
    padding: 0;
    border-top: 1px solid ${colors.grayOp07};
    border-bottom: 1px solid ${colors.grayOp07};
    height: ${blocks.menuHeight};
  `}

  > .swiper-container {
    height: 100%;
  }
`

export const SSMobileMenuItem = styled.div`
  height: inherit;
  white-space: nowrap;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;
  cursor: pointer;
  opacity: ${({ isActive }) => (isActive ? `1` : `0.4`)};

  ${({ idx }) =>
    !idx &&
    `
    margin-left: 20px;
  `}

  ${({ idx, length }) =>
    idx === length - 1 &&
    `
    margin-right: 20px;
  `}

  &.swiper-slide {
    width: auto;
  }
`
